import React, { Component } from 'react';
import '../css/validations.css'
import { FORMAT_NUMBER, CURRENCY, SYMBOL } from '../libs/utils/Const';

class PartialPaymentModal extends Component {
   

    render() {
        const { 
            ModelCollect,
            OpenCuentaMayor,
            changeCashSumEnter,
            changeCashSum,
            validateCashSumNull,
            changeTrsfrSum,
            validateTrsfrSumNull,
            openCheckList,
            Abonar,
            changeAccountCashAcct,
            changeAccountCheck,
            changeAccountTrsfr,
            OpenPaymentCreditCards,
        } = this.props;
        
        return (
            <div>
                <div className="modal fade" id="partialPaymentModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="partialPaymentModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={ {boxShadow: "1px 1px 10px rgba(1,1,1,0.3)"}}>
                            <div className="modal-body">
                                <form>
                                    <div className="">
                                        <h4 className="title">Pago total: </h4>
                                        <div className="card row " style={{fontSize: "xxx-large", background: "#00800012", border: "none", boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                            <div className=" text-center col-12 pb-2" >
                                            <span style={{ color: "green" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(ModelCollect.totalPago)}</span>
                                            </div>
                                        </div>
                                        <br></br>
                                    </div>
                                    <div className="">
                                        {/* <h4 className="title">Forma de pago</h4> */}
                                        {/* <div className="row mt-4 pr-2">
                                            <div className="col-4">
                                                <label className="form-label pl-4 mt-1"><h5>Moneda: </h5></label>
                                            </div>
                                            <div className="col-3">
                                                <select className="form-control  text-center" >
                                                    <option selected>MXP</option>
                                                    <option value="1">US</option>
                                                </select>
                                            </div>
                                        </div> */}
                                        {/* EFECTIVO */}
                                        <div className="row mt-4 pr-2">
                                            <div className="col-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Cuenta</strong></span>
                                                    </div>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        // disabled="true"
                                                        onChange={changeAccountCashAcct}
                                                        value={ModelCollect.CashAcctFormatCode ? ModelCollect.CashAcctFormatCode : ''}/>
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        onClick={() => OpenCuentaMayor(0, 4)}
                                                        >
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Efectivo:</strong></span>
                                                    </div>
                                                    <input
                                                        type=" text"
                                                        className="form-control btn-outline-secondary"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            textAlign: "right",
                                                        }}
                                                        value={ModelCollect.CashSum}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                changeCashSumEnter();
                                                            }
                                                        }}
                                                        onChange={changeCashSum}
                                                        onBlur={validateCashSumNull}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* CHEQUES */}
                                        <div className="row mt-4 pr-2">
                                            <div className="col-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Cuenta</strong></span>
                                                    </div>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        // disabled="true"
                                                        onChange={changeAccountCheck}
                                                        value={ModelCollect.CheckAcctFormatCode ? ModelCollect.CheckAcctFormatCode : ''}/>
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        onClick={() => OpenCuentaMayor(0, 3)}
                                                        >
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Lista de cheques:</strong></span>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        onClick={() => openCheckList()}
                                                        >
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* TRANSFERENCIA */}
                                        <div className="row mt-4 pr-2">
                                            <div className="col-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Cuenta</strong></span>
                                                    </div>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        // disabled="true"
                                                        onChange={changeAccountTrsfr}
                                                        value={ModelCollect.TrsfrAcctFormatCode ? ModelCollect.TrsfrAcctFormatCode : ''}/>
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        onClick={() => OpenCuentaMayor(0, 2)}
                                                        >
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Transferencia:</strong></span>
                                                    </div>
                                                    <input
                                                        type=" text"
                                                        className="form-control btn-outline-secondary"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000',
                                                            textAlign: "right",
                                                        }}
                                                        value={ModelCollect.TrsfrSum}
                                                        onChange={changeTrsfrSum}
                                                        onBlur={validateTrsfrSumNull}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* TARJETA */}
                                        <div className="row mt-4 pr-2">
                                            <div className="col-12">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Tarjeta de crédito:</strong></span>
                                                    </div>
                                                    <input 
                                                        type="text" 
                                                        className="form-control input-sm" 
                                                        id="txtName"
                                                        disabled="true"
                                                        value={ModelCollect.CreditSum ? ModelCollect.CreditSum : ''}/>
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        onClick={() => OpenPaymentCreditCards()}
                                                        >
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="row mt-3 pr-2">
                                            <div className='pl-4 col-12'>
                                                <select className="form-control  text-center" >
                                                    <option selected>Tipo de tarjeta</option>
                                                    <option value="1">BANCOMER CREDITO</option>
                                                    <option value="2">BANAMEX DEBITO</option>
                                                    <option value="3">HSBC CREDITO</option>
                                                    <option value="4">SANTANDER DEBITO</option>
                                                    <option value="5">SCOTIABANK CREDITO</option>
                                                    <option value="6">BANORTE DEBITO</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row mt-3 pr-2">
                                            <div className="col-3">
                                                <label className="form-label pl-4 mt-1"><h5>Tarjeta:</h5></label>
                                            </div>
                                            <div className="col-4">
                                                <input className="form-control" type="text" placeholder="N° de voucher"/>
                                            </div>
                                            <div className="col-5">
                                                <input 
                                                    className="form-control" 
                                                    type="text" 
                                                    placeholder="Monto del voucher"
                                                    />
                                            </div>
                                        </div> */}
                                    </div>
                                    
                                    <div className="card-details">
                                        <h4 className="title mt-4">Por pagar:</h4>
                                        <div className="card row" style={{fontSize: "xxx-large", border: "none", background: "#0499f212", boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                            <div className=" text-center col-12 pb-2" >
                                            <span style={{ color: "#0458b2", fontWeight: "bold" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(ModelCollect.totalRestante)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                <button 
                                    type="button" 
                                    className="btn btn-primary" 
                                    // data-dismiss="modal" 
                                    // ata-toggle="modal" 
                                    // data-target="#vmSettle" 
                                    onClick={() => Abonar()}
                                >
                                    <i className="fa fa-plus-circle mr-2" aria-hidden="true"/>
                                    Hacer Abono
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <ValidationModal
                    idValidation="vmSettle"
                    message="¿Abonar a la factura?"                    
                    idModalOrigin="#partialPaymentModal"
                    idModalDestiny="#collectModal"
                    eventOnclick={Abonar} 
                />*/}
            </div>
        );
    }
}

export default PartialPaymentModal;